'use client'
import {
  useConfig_default
} from "./chunk-AVLZHNEN.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/hooks/useGeolocation.ts
import { useMemo } from "react";
import { COUNTRIES } from "@wbk/utils";
var useGeolocation = () => {
  const geoLocation = useConfig_default().geoLocation;
  const country = useMemo(
    () => COUNTRIES.find((item) => item.code === (geoLocation == null ? void 0 : geoLocation.countryCode)),
    [geoLocation == null ? void 0 : geoLocation.countryCode]
  );
  return __spreadProps(__spreadValues({}, geoLocation), {
    countryCode: (geoLocation == null ? void 0 : geoLocation.countryCode) || "SA",
    country
  });
};

export {
  useGeolocation
};
//# sourceMappingURL=chunk-SHJYKVSE.mjs.map